import { getType } from 'typesafe-actions'

import { Dictionary } from '../../utils/types'
import { withLoadingReducer } from '../loading'

import { DomainsActions } from './actions'
import { DomainState, Town } from './types'

export const initState: DomainState = { data: {} }

export const reducer = (state: DomainState = initState, action: DomainsActions): DomainState => {
  switch (action.type) {
    case getType(DomainsActions.setDomainData): {
      const { language } = action.payload
      return {
        ...state,
        data: {
          ...state.data,
          [language]: {
            ...state.data[language],
            domains: {
              ...(state.data[language]?.domains || {}),
              [action.payload.domainType]: action.payload.data
            }
          }
        }
      }
    }
    case getType(DomainsActions.setStates): {
      const { language, countryCode, data } = action.payload
      return {
        ...state,
        data: {
          ...state.data,
          [language]: {
            ...state.data[language],
            states: {
              ...(state.data[language]?.states || {}),
              [countryCode]: data
            }
          }
        }
      }
    }
    case getType(DomainsActions.setTowns): {
      const { language, stateCode, data } = action.payload
      return {
        ...state,
        data: {
          ...state.data,
          [language]: {
            ...state.data[language],
            towns: {
              ...((state.data[language]?.towns || {}) as Dictionary<Town[]>),
              [stateCode]: data
            }
          }
        }
      }
    }
    default:
      return state
  }
}

export const domainReducer = withLoadingReducer(reducer, 'domains', initState)
